export const reducerFn = (state, payload) => {
    const { type, content } = payload;
    const { key, value } = content;

    switch (type) {
        case 'add_indicator_pt':
            const updatedIndicatorsPt = state.indicatorsPt.map(indicator => {
                if (indicator.key === key) {
                    return { ...indicator, value };
                }
                return indicator;
            });

            return {
                ...state,
                indicatorsPt:  updatedIndicatorsPt
            };

        case 'add_indicator_en':
            const updatedIndicatorsEn = state.indicatorsEn.map(indicator => {
                if (indicator.key === key) {
                    return { ...indicator, value };
                }
                return indicator;
            });

            return {
                ...state,
                indicatorsEn: updatedIndicatorsEn
            };

        default:
            return state;
    }
};





